import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, ButtonProps } from "@wojo/ui";
import cn from "clsx";
import { useEffect, useState } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import styles from "./EquipmentModal.module.scss";

type EquipmentModalNavProps = {
    handleNextClick: () => void;
    handlePrevClick: () => void;
    className?: string;
    tourEquipmentTitle: string;
};

export const EquipmentModalNav: React.FC<EquipmentModalNavProps> = ({
    handleNextClick,
    handlePrevClick,
    className,
    tourEquipmentTitle,
}) => {
    const { productPage } = useI18n("productPage");
    const [currentTitle, setCurrentTitle] = useState(tourEquipmentTitle);
    const prevButtonProps: Partial<ButtonProps<"button">> = {
        variant: "quiet",
        adornLeft: <FiArrowLeft aria-hidden />,
        onClick: () => {
            gtmSendEvent({
                event: "track",
                ga4Tracking: {
                    ga4_object: "EQUIPMENT_MODAL",
                    ga4_action: "SCROLLED",
                    modalId: "Equipment Modal",
                },
            });
            handlePrevClick();
        },
    };

    useEffect(() => {
        setCurrentTitle(tourEquipmentTitle);
    }, [tourEquipmentTitle]);

    return (
        <section
            className={cn(styles.nav, className)}
            aria-label={productPage.equipment.accessibleMediaControlsLabel.l()}
        >
            <Button {...prevButtonProps} className={styles["desktop-only"]}>
                {productPage.equipment.previousItem.l()}
            </Button>
            <Button {...prevButtonProps} className={styles["mobile-only"]}>
                {productPage.equipment.previousItemMobile.l()}
            </Button>
            <Button
                variant="quiet"
                adornRight={<FiArrowRight aria-hidden />}
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "EQUIPMENT_MODAL",
                            ga4_action: "SCROLLED",
                            modalId: "Equipment Modal",
                        },
                    });
                    handleNextClick();
                }}
            >
                {productPage.equipment.nextItem.l()}
            </Button>
            <div aria-live="polite" className="visually-hidden">
                {currentTitle}
            </div>
        </section>
    );
};
